<template lang="pug">
.chart-container(:style="{ height: svgHeight + 10 + 'px' }")
  .scroll-vertical(:style="{ height: svgHeight + 'px' }")
    .axis
      svg(
        width="60",
        :height="svgHeight",
        style="position: absolute; left: 0; top: 0"
      )
        text(
          v-for="y in logLines",
          :x="10",
          :y="scaleY(y) - 2",
          font-size="10",
          fill="#444"
        ) {{ y < -1 || y > 1 ? y.toLocaleString("de-DE") : 0 }}

    .bars
      svg(:width="svgWidth", :height="svgHeight")
        line(
          v-for="y in logLines",
          :key="y",
          :x1="0",
          :y1="scaleY(y)",
          :x2="svgWidth",
          :y2="scaleY(y)",
          stroke="#ccc",
          stroke-dasharray="4"
        )
        rect(
          v-for="(win, i) in wins",
          :key="'w' + i",
          :x="i * barWidth + 10",
          :y="barY(win.netto)",
          :width="barWidth - 1",
          :height="barHeight(win.netto)",
          :fill="win.netto >= 0 ? '#88ff88' : '#ff8888'"
        )

        path(:d="linePath", fill="none", stroke="blue", stroke-width="2")

        svg.axis-x(:width="svgWidth", height="900")
          g(
            v-for="tick in getMonthTicks()",
            :key="tick.x",
            :transform="`translate(${tick.x + barWidth + 1}, 0)`"
          )
            line(:y2="10", stroke="black")
            line(v-if="!tick.isJanuary" :y1="16" :y2="svgHeight", stroke="silver" stroke-dasharray="1,1")
            line(v-if="tick.isJanuary" :y1="16" :y2="svgHeight", stroke="black" stroke-dasharray="1,1")
            text(y="10", x="4", text-anchor="left", font-size="10") {{ tick.label }}
</template>

<script>
export default {
  name: "WinTimelineChart",
  components: {},
  props: {
    wins: Array, // Array of { date, brutto } sorted by date
  },
  data() {
    return {};
  },
  computed: {
    svgWidth() {
      return this.wins.length * this.barWidth + 140;
    },
    svgHeight() {
      //   return window.innerHeight; // 600;
      const c = document.getElementsByClassName("chart");
      if (c && c.length) {
        return c.offsetHeight;
      }
      return window.innerHeight;
    },
    barWidth() {
      return 6;
    },
    linePath() {
        let max = 0;
      const points = this.wins.map((y, i) => {
        if (y.cumulative < max)
            max = y.cumulative;
        return `${i * this.barWidth + 10 + this.barWidth / 2},${this.scaleY(
          y.cumulative
        )}`;
      });
      return `M${points.join(" L")}`;
    },
//     linePath() {
//       const n = this.wins.length;
//       let max = 0;
//       console.log(this.wins);
//       const log = [];
//       const points = this.wins
//         .slice() // Kopie, um Original nicht zu verändern
//         .reverse() // frühestes Datum zuerst (rechts)
//         .map((y, i) => {
//           if (y.cumulative < max) max = y.cumulative;
//           // X von rechts nach links aufbauen
//           const x = (n - 1 - i) * this.barWidth + 10 + this.barWidth / 2;
//           const yPos = this.scaleY(y.cumulative);
//           log.push(`${i}: ${n-1-i} ${y} ${y.cumulative}`);
//           return `${x},${yPos}`;
//         });

// console.log(log.join(', '));
//       return `M${points.join(" L")}`;
//     },
    maxAbs() {
      const max = Math.max(...this.wins.map((w) => Math.abs(w.cumulative)), 1);
      return max;
    },
    logLines() {
      // Referenzlinien bei +/-10, 100, 1000, usw.
      const v = [
        0, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000,
        50000, 100000, 200000, 500000, 1000000, 2000000, 5000000,
      ];
      const levels = [];
      v.forEach((x) => {
        if (x == 0) levels.push(x);
        else levels.push(x, -x);
      });
      return levels;
    },
  },

  methods: {
    // y-Koordinaten für die logarithmische Skalierung (log(y) und -log(-y))
getMonthTicks() {
  const months = [
    "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
    "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
  ];

  if (!this.wins.length) return [];

  const ticks = [];

  // Ziehungsdaten als Date-Objekte vorbereiten
  const dates = this.wins.map(w => new Date(w.date));

  // Start: erster Tag des Vormonats der ersten Ziehung
  const first = dates[0];
  let cursor = new Date(first.getFullYear(), first.getMonth() - 1, 1);

  const last = dates[dates.length - 1];

  while (cursor <= last) {
    // erste Ziehung >= Monatsanfang finden
    const index = dates.findIndex(d => d >= cursor);

    if (index !== -1) {
      const month = cursor.getMonth();
      const year  = cursor.getFullYear();

      ticks.push({
        x: index * this.barWidth,
        date: new Date(cursor),
        isJanuary: month === 0,
        label:
          (month === 0 ? `${year} ` : "") + months[month]
      });
    }

    // nächster Monat
    cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
  }

  return ticks.slice(1);
},

    scaleY(value) {
      const center = this.svgHeight / 2;
      if (value === 0) return center;
      const sign = Math.sign(value);
      const magnitude = Math.log10(Math.abs(value));
      const maxLog = 7; // log10(10000) = 4
      const factor = this.svgHeight / 2 / maxLog;
      return center - sign * magnitude * factor;
    },
    barHeight(value) {
      const zeroY = this.scaleY(0);
      const y = this.scaleY(value);
      return Math.abs(zeroY - y);
    },
    barY(value) {
      const y = this.scaleY(value);
      return value >= 0 ? y : this.scaleY(0);
    },
  },
};
</script>

<style scoped>
.chart-container {
  overflow: auto;
  position: relative;
  border: 1px solid gray;
  display: flex;
  flex-direction: row;
}

.scroll-vertical {
  display: flex;
  overflow-y: auto; /* Vertikal scrollen beide gemeinsam */
  flex: 1;
}

.axis {
  width: 60px;
  flex: 0 0 60px;
  background: #f9f9f9;
  border-right: 1px solid #ccc;
}

.scroll-horizontal {
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
}

.bars {
  margin: 0;
  padding: 0;
  min-width: 100%; /* für scrollbaren Bereich */
  overflow-y: hidden;
}
</style>
